// Global Instructions Rule Applied!

import { GlobalConfigRecord } from '../../data_models/global_config_record.ts'
import {
  SET_GLOBAL_CONFIGS,
  CLEAR_GLOBAL_CONFIGS_DATA,
  REMOVE_USER_PREFERENCE_FOR_MENU_ITEM,
  MERGE_USER_PREFERENCE_ROW_DATA,
  SET_USER_PREFERENCES_APP_DATA,
  UPDATE_GLOBAL_CONFIG_FUND,
  ADD_GLOBAL_CONFIG_FUND
} from './constants.ts'
import {
  ClearGlobalConfigsDataAction,
  MergeUserPreferenceRowDataAction,
  RemoveUserPreferenceForMenuItemAction,
  SetGlobalConfigsAction,
  SetUserPreferencesAppDataAction,
  UpdateGlobalConfigFundAction,
  AddGlobalConfigFundAction
} from '../../interfaces/global_configs.ts'

export const setGlobalConfigs = (global_configs: GlobalConfigRecord): SetGlobalConfigsAction => ({
  type: SET_GLOBAL_CONFIGS,
  payload: { global_configs }
})

export const clearGlobalConfigsData = (): ClearGlobalConfigsDataAction => ({
  type: CLEAR_GLOBAL_CONFIGS_DATA
})

export const removeUserPreferenceForMenuItem = (menuItemId: string): RemoveUserPreferenceForMenuItemAction => ({
  type: REMOVE_USER_PREFERENCE_FOR_MENU_ITEM,
  payload: { menu_item_id: menuItemId }
})

export const mergeUserPreferenceRowData = (
  menuItemId: string,
  data: Record<string, unknown>
): MergeUserPreferenceRowDataAction => ({
  type: MERGE_USER_PREFERENCE_ROW_DATA,
  payload: { menu_item_id: menuItemId, data }
})

/** Merge keys into the per-user global (non-report) preference blob. Unlike
 * mergeUserPreferenceRowData this UPSERTS — it creates the row when absent, so
 * the first write of a preference needs no global-configs refetch. */
export const setUserPreferencesAppData = (
  data: Record<string, unknown>
): SetUserPreferencesAppDataAction => ({
  type: SET_USER_PREFERENCES_APP_DATA,
  payload: { data }
})

/** Merge patched fund columns (e.g. pipeline_origination) into the matching
 * globalConfigs.funds entry so fund-derived logic (kanban stage defaults,
 * Bulk Add Prospects) tracks the edit without a full configs reload. */
/** Prepend a freshly created fund (lean get_global_configs_v3 shape) to
 * globalConfigs.funds so every fund picker sees it in this session. The
 * config-version spine watches public.funds, so other clients and the
 * backend cache catch up on their next poll without a restart. */
export const addGlobalConfigFund = (fund: AddGlobalConfigFundAction['payload']['fund']): AddGlobalConfigFundAction => ({
  type: ADD_GLOBAL_CONFIG_FUND,
  payload: { fund }
})

export const updateGlobalConfigFund = (
  fundId: string,
  updates: Record<string, unknown>
): UpdateGlobalConfigFundAction => ({
  type: UPDATE_GLOBAL_CONFIG_FUND,
  payload: { fund_id: fundId, updates }
})
